import {memo, PropTypes, propTypesExact, shapeComponent, ShapeComponent, Text, useStyles, View} from "shared/base"
import {Pressable, StyleSheet} from "react-native"
import Card from "components/chalky-layout/card"
import Icon from "@kaspernj/api-maker/build/utils/icon"
import PageContentsPresentation from "components/page-contents/presentation"
import React from "react"

const styles = StyleSheet.create({
  cardHeader: {
    marginBottom: 15
  },
  cardHeaderSmDown: {
    flexDirection: "row",
    alignItems: "center"
  },

  cardHeaderText: {
    fontSize: 24,
    fontWeight: "bold"
  },
  cardHeaderTextSmDown: {
    marginLeft: 4
  },
  cardHeaderTextMdUp: {
    marginTop: 15
  },

  activeCheckIcon: {color: "#5253ff"},

  activeCheckContainer: {
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    zIndex: 998,
    right: 24,
    bottom: 24,
    width: 24,
    height: 24,
    backgroundColor: "#fff",
    borderRadius: "50%"
  },
  activeCheckContainerMdUp: {
    width: 40,
    height: 40
  },

  iconContainer: {},
  iconContainerSmDown: {
    marginRight: 8
  }
})

export default memo(shapeComponent(class RoutesUserCreateUserRoleCard extends ShapeComponent {
  static defaultProps = {
    icon: null,
    iconVersion: "FontAwesome",
    liquidVariables: undefined
  }

  static propTypes = propTypesExact({
    active: PropTypes.bool.isRequired,
    header: PropTypes.string.isRequired,
    icon: PropTypes.string,
    iconVersion: PropTypes.string.isRequired,
    identifier: PropTypes.string.isRequired,
    liquidVariables: PropTypes.object,
    onCardPress: PropTypes.func.isRequired
  })

  render() {
    const {active, header, icon, iconVersion, identifier, liquidVariables} = this.p
    const cardHeaderStyle = useStyles(styles, ["cardHeader"])
    const cardHeaderTextStyle = useStyles(styles, ["cardHeaderText"])
    const activeCheckContainerStyle = useStyles(styles, ["activeCheckContainer"])
    const iconContainerStyle = useStyles(styles, "iconContainer")

    return (
      <Pressable dataSet={this.pressableDataSet ||= {component: "routes/user/create-user/role-card", identifier}} onPress={this.tt.onCardPress}>
        <Card active={active} style={this.cardStyle ||= {minHeight: 410}}>
          {active &&
            <View style={activeCheckContainerStyle}>
              <Icon name="check" style={styles.activeCheckIcon} />
            </View>
          }
          <View style={this.cardInnerCenterViewStyle ||= {justifyContent: "center", height: "100%"}}>
            <View>
              <View style={cardHeaderStyle}>
                {icon &&
                  <View style={iconContainerStyle}>
                    <Icon name={icon} size={32} version={iconVersion} />
                  </View>
                }
                <Text style={cardHeaderTextStyle}>
                  {header}
                </Text>
              </View>
              <PageContentsPresentation
                identifier={`routes/user/create-user/role-card/description/${identifier}-description`}
                liquidVariables={liquidVariables}
              />
            </View>
          </View>
        </Card>
      </Pressable>
    )
  }

  onCardPress = () => this.p.onCardPress({identifier: this.p.identifier})
}))
